import { FieldStub } from "./_FieldStub";
import type { FieldPrimitiveProps } from "./types";

// STUB — CHG-1167 scaffold. Real impl lands ε CHG-1150.
// Contract: specs/_product/field-primitive-registry.md §1 ('donor_picker').
// Doctrine: feedback_field_primitive_components_canonical.md.

export function DonorPicker(props: FieldPrimitiveProps<string>) {
  return <FieldStub {...props} fieldType="donor_picker" inputType="text" />;
}
